<ng-container *ngIf="data$ | async as data"> </ng-container>
<div
  class="flex flex-row flex-wrap content-start gap-4 p-4 w-full h-full overflow-auto"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [scrollWindow]="false"
  (scrolled)="onScroll()"
  [cslOverlayLoader]="loading$">
  <cutting-product-card
    *ngFor="let item of data"
    [product]="item"
    [priceListId]="priceList.id"
    (selectedProductChange)="selectProduct($event)"></cutting-product-card>
</div>
